import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Upload extends Base {
    constructor(props) {
        super(props);
        this.state = {
            type: props.Type,
            file: '',
            loading: true,
            datares: null

        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/get")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    uploadFile(event) {
        var _this = this;
        let file = event.target.files[0];
        if (file) {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                _this.state.file = reader.result;
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }
    }
    save(e) {
        e.preventDefault();
        if (this.isBlank(this.state.file)) {
            this.showErorrMessage('لطفا فایل اکسل مورد نظر خود را اپلود نمایید');
            return;
        }
        var url = "";
        var redirectUrl = "";
        if (this.state.type === 1) {
            url = "api/v1/invoice/upload";
            redirectUrl = "/invoices";
        }
        if (this.state.type === 2) {
            url = "api/v1/person/upload";
            redirectUrl = "/persons";
        }
        if (this.state.type === 3) {
            url = "api/v1/stuff/upload";
            redirectUrl = "/stuffs";
        }
        if (this.state.type === 4) {
            url = "api/v1/invoice/uploadexceltax";
            redirectUrl = "/invoices";
        }
        this.httpPost(url, {
            companyId: this.state.data.global.company.id,
            file: this.state.file
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    if (this.state.type === 4) {
                        this.showSuccessMessage("اطلاعات با موفقیت بررسی شد");
                        const linkSource = `data:application/zip;base64,${data.bs64}`;
                        const downloadLink = document.createElement("a");
                        const fileName = "export.xlsx";
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                        this.setState({ loading: false });
                        this.setState({
                            datares: data
                        })
                    }
                    else {
                        this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                        this.setState({
                            redirect: redirectUrl
                        })
                    }

                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.")
            });
    }
    getExcelTemplate() {
        var p = "";
        if (this.state.type === 1) {
            p = "/template/invoice.xlsx";
        }
        if (this.state.type === 2) {
            p = "/template/person.xlsx";
        }
        if (this.state.type === 3) {
            p = "/template/stuff.xlsx";
        }

        return p;
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="card-head">
                                            <h5 className="card-title">ورود اکسل اطلاعات</h5>
                                        </div>
                                        <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                            <div className="uploadBox">


                                                {this.state.type !== 4 &&
                                                    <div>
                                                        <p>از طریق این بخش می تواند اطلاعات خود را به صورت دسته جمعی از طریق فایل اکسل وارد سامانه نمایید.</p>
                                                        <p>برای اینکار بایستی ابتدا فایل اکسل نمونه را دانلود کرده و پس از تکمیل فایل از طریق فرم زیر ارسال نمایید.</p>
                                                        <div class="example-alert">
                                                            <div class="alert alert-warning alert-icon">
                                                                <em class="icon ni ni-alert-circle"></em>
                                                                <p>لطفا در فایل مورد نظر استفاده از فرمول و اعداد اعشاری خودداری نمایید.</p>
                                                            </div>
                                                        </div>
                                                      
                                                        <a style={{ "color": "#28bc36", "font-weight": "bold" }} href={this.getExcelTemplate()} target="_blank">دانلود فایل اکسل نمونه</a>

                                                    </div>                        

                                                }
                                                {this.state.type === 4 &&    
                                                    <div>
                                                        <p>مغایرت گیری فایل خروجی کارپوشه در با سیستم</p>
                                                        <div class="example-alert">
                                                            <div class="alert alert-warning alert-icon">
                                                                <em class="icon ni ni-alert-circle"></em>
                                                                <p>فایل CSV خروجی کارپوشه را بدون تغییر آپلود نمایید.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                }
                                                <div style={{ "margin": "40px 0" }} >
                                                    <input type="file" onChange={e => this.uploadFile(e)} />
                                                    <button onClick={e => this.save(e)} className="btn btn-primary">ارسال</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <br />
                                {this.state.datares !== null &&

                                    <div className="card-inner p-0">
                                        <div className="nk-tb-list nk-tb-ulist">
                                            <div className="nk-tb-item nk-tb-head" style={{ backgroundColor: "#16498a" }}>
                                                <div className="nk-tb-col"><span className="sub-text text-white">نوع حساب</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">الگوی صورت حساب</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">موضوع صورت حساب</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">شماره صورت حساب</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">مجموع صورت حساب</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">وضعیت صورت حساب</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">مالیات صورت حساب</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">تاریخ صورت حساب</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">شناسه هویتی خریدار</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">نام خریدار</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">نوع خریدار</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">شماره مالیات صورت حساب مرجع</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">وضعیت حد</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">وضعیت</span></div>
                                            </div>
                                            {this.state.datares.exportExcels.map((record, index) =>
                                                <div className="nk-tb-item">

                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.nhesab}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.olHesab}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.msHesab}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.taxId}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.msoratHesab}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.vaziyatSorat}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.maliatSorat}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.tarikhSorat}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.shenaseHov}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.nameKharidar}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.noeKharidar}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.shMaliatSoratMarja}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.had}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className={"sub-text text-center" + record.status === 2 ? " text-warning" : " text-danger"}>{record.statusStr}</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                }


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}